import styled from "styled-components"

/**
 * BaseCardProps allows for additional HTML attributes or style overrides.
 */
export interface BaseCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Optional: If you want to allow custom background or other overrides.
   */
  background?: string
}

/**
 * A modern, glassy card container with subtle corners and shadows.
 * This is a domain-agnostic container for any "card" content.
 */
export const BaseCard = styled.div<BaseCardProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.components.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.components.boxShadow.medium};
  padding: ${({ theme }) => theme.spacing.md};
  backdrop-filter: blur(10px);
  background: ${({ background, theme }) => background || "rgba(255, 255, 255, 0.8)"};
  color: ${({ theme }) => theme.primaryText};
  /* Subtle borderless aesthetic */
  border: none;
`

export default BaseCard
